import { html } from 'lit';
import type { TefComs4p } from '@src/components/TefComs4p.js';
import { componentStateStore } from '@src/store/index.js';

//
// renders the main compoennt view
//
export const tefComs4pEdit = function render(this: TefComs4p) {
  return html`
    <one-stack gap="sm">
      <one-content>
        <one-heading level="h4" variant="default">Partner-APP Einstellungen</one-heading>
        <one-text as="p">
          Im Folgenden können Sie die Einstellungen Ihrer Partner-APP für Ihre Rufnummern einsehen und ändern.
        </one-text>
        ${this.getTemplateFn('singlePurposeEdit')(componentStateStore.activePurpose)}
      </one-content>
      <one-content>
        <one-cluster x="space-between" no-wrap>
          <tef-coms-cancel-button text="Abbrechen"></tef-coms-cancel-button>
          <one-button variant="solid" size="medium" type="button" @click=${this.saveConsentsForActivePurpose}>Speichern</one-button>
        </one-cluster>
      </one-content>
    </one-stack>
  `;
};
